import throttle from "./throttle.mjs";
export default (t, f) => {
    const xs = [];
    const cb = throttle(t, () => xs.length > 0 && f(xs.splice(0)));
    return (x) => {
        xs.push(x);
        cb();
    };
};
//# sourceMappingURL=batch.mjs.map